const disbursementRequestStatus = Object.freeze({
  Nuevo: 1,
  Sometido: 2,
  DevueltoARevision: 3,
  ProcesoDeRevision: 4,
  SometidoRevisado: 5,
  PendienteDeAprobacion: 6,
  Aprobado: 7,
  EnviadoAFinanzas: 8,
  Pagado: 9,
  Cancelado: 10,
  EnProcesoDePago: 11,
  DevueltoTPFA: 13,
});
export default disbursementRequestStatus;
